// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Traducoes_CriarChaveResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for POST /config/traducoes/chave.
 *
 * `traduzido_automaticamente` is false when every non-default language came back
 * equal to the key — the shape upstream produces when Google Translate is not
 * configured or refused. It says "the key exists but nobody translated it", so
 * the caller can tell a working create from a silently half-done one.
 */
import type { Traducoes_ItemRow } from './Traducoes_ItemRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Traducoes_CriarChaveResponseDados {
item: Traducoes_ItemRow
traduzido_automaticamente: boolean
}

export type Traducoes_CriarChaveResponse = ApiResponse<Traducoes_CriarChaveResponseDados>;

registerResponseContract('Traducoes_CriarChaveResponse', {
  item: {
    type: 'object',
    required: false,
    fields: {
      pagina:    { type: 'string',  required: false },
      chave:     { type: 'string',  required: false },
      traducoes: { type: 'object',  required: false },
      faltantes: { type: 'array',   required: false },
    },
  },
  traduzido_automaticamente: { type: 'boolean', required: true },
})
